import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NavigateBackService } from '../../../../services/navigate-back.service';
@Component({
  selector: 'nx-ng-current-page-indicator',
  templateUrl: './current-page-indicator.component.html',
  styleUrls: ['./current-page-indicator.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CurrentPageIndicatorComponent {
  constructor(private navigateBackService: NavigateBackService) {}
  @Input()
  currentPageTitle = '';

  @Input()
  showBackButton = true;

  handleClick() {
    this.navigateBackService.back();
    return false;
  }
}
